<div class="alert-body">
    <i class="fal fa-check-circle fa-5x"></i>
    <h4>{{ 'ONBOARDING.VERIFY_EMAIL_SUCCESS_MODAL.TITLE' | translate }}</h4>
    <p>{{ 'ONBOARDING.VERIFY_EMAIL_SUCCESS_MODAL.FIRST_TEXT' | translate }}</p>
    <p class="text-gray">{{ 'ONBOARDING.VERIFY_EMAIL_SUCCESS_MODAL.SECOND_TEXT' | translate }}</p>
    <button nz-button nzType="primary" (click)="clickOk()">{{ 'ONBOARDING.VERIFY_EMAIL_SUCCESS_MODAL.BUTTON_OK' | translate }}</button>
</div>